
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import { partnerEntity } from '@/models/models'
import CommonForm from '@/mixins/CommonForm'
import { CNPJ_MASK } from '@/constants/cnpj'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        AppInput,
    },
})

export default class PartnerFormCompanyData extends CommonForm {
    @Prop() public value?: PartnerEntity

    public readonly CNPJ_MASK = CNPJ_MASK

    get partner(): PartnerEntity {
        return this.value ?? partnerEntity
    }

    get categoriesOptions(): InputSelectOptionEntity[] {
        const categories = cloneDeep(this.$store.state.partnerForm.categories)

        const mappedCategories = categories.map((category: PartnerCategoryEntity) => {
            return { value: category.id, text: category.name }
        })

        const emptyCategory = [{ value: '', text: '' }]
        const allCategories = emptyCategory.concat(mappedCategories)

        return allCategories
    }
}
